import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class NetPromoterNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
            for (let i = 0; i < this.defaultFocusStatus.statuses.length; i++) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];

                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId &&
                    i > index
                ) {
                    return elementFocusStatus;
                }
            }
        } else if (eventKey === "ArrowUp" || eventKey === "ArrowLeft") {
            for (let i = this.defaultFocusStatus.statuses.length - 1; i >= 0; i--) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];
                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId &&
                    i < index
                ) {
                    return elementFocusStatus;
                }
            }
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index + 1, len = this.defaultFocusStatus.statuses.length; i < len; i++) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];

            if (
                elementFocusStatus.variableId !== 0 &&
                elementFocusStatus.elementRef?.current &&
                elementFocusStatus.variableId !== currentElement.variableId
            ) {
                return this.getFocusableElement(elementFocusStatus, true);
            }
        }

        return null;
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findLastFocusableElementWithinPreviousVariableCommon(currentElement);
    }
}
